/**
 * Timekeeper
 *
 * Keeps track of the current time on redux state.
 * Updates every minute by default.
 */

import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

// Actions
import updateTime from '../../services/timekeeper/actions';

interface Props {
    updateTime: Function;
    interval?: number;
}

const getTime = () =>
    moment()
        .utc()
        .format();

export class Timekeeper extends React.PureComponent<Props> {
    static defaultProps = {
        interval: 60000
    };

    componentDidMount() {
        const { interval, ...props } = this.props;

        // Initial update
        props.updateTime(getTime());

        this.timer = setInterval(() => {
            props.updateTime(getTime());
        }, interval);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        return null;
    }
}

export default connect(
    null,
    { updateTime }
)(Timekeeper);
